var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":"","dismissible":"","variant":"warning"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v(" Warning! ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('manageToken.complianceRules.warning'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }